import Vue from 'vue';
import loading from '../components/loading.vue';

// 扩展实例构造器
const LoadingConstructor = Vue.extend(loading);

// 创建一个vue实例，挂载元素为新创建的div
let initLoadingInstance = function () {
    return new LoadingConstructor({
        el: document.createElement('div'),
    });
}

// 删除dom节点
let removeDom = (node) => {
    if (node.parentNode) {
        node.parentNode.removeChild(node);
    }
};

let instance = initLoadingInstance();

// 关闭loading
let closeLoading = () => {
    removeDom(instance.$el)
};

// 展示loading
let showLoading = function () {
    //document.body.appendChild(instance.$el);
    document.getElementById("app").appendChild(instance.$el);
}

export default {
    showLoading,
    closeLoading
}


// WEBPACK FOOTER //
// ./src/util/loading.js